import { createRoot } from 'react-dom/client'
import { HoxRoot } from 'hox'
import disableDevtool from 'disable-devtool'
import App from './App.tsx'
import { App as AntdApp, ConfigProvider } from 'antd'
import './index.less'
import '@/assets/css/reset.css'
import '@/assets/css/resetAntd.scss'
import '@/assets/css/global.scss'
import '@/i18n/index.ts'
import '@/utils/reponsive.ts'

const shouldDisableDevtool =
  import.meta.env.PROD && ['production', 'uat'].includes(import.meta.env.VITE_NODE_ENV)

if (shouldDisableDevtool) {
  let devtoolOpenHandled = false

  disableDevtool({
    md5: '8afc89be352812a4c2567f5196586f13',
    detectors: 'all',
    interval: 200,
    // 防止模拟手机模式被识别为移动端后，5 秒自动停止检测。
    stopIntervalTime: 2_147_483_647,
    clearIntervalWhenDevOpenTrigger: true,
    timeOutUrl: 'about:blank',
    ondevtoolopen(_type, next) {
      if (devtoolOpenHandled) return
      // 多个检测器可能连续触发，弹窗前标记以避免重复处理。
      devtoolOpenHandled = true
      window.alert('Developer tool detected, page will be closed')
      next()
    },
  })
}

createRoot(document.getElementById('root')!).render(
  <ConfigProvider>
    <AntdApp>
      <HoxRoot>
        <App />
      </HoxRoot>
    </AntdApp>
  </ConfigProvider>,
)
